<svg width="30px" height="30px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Artboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" font-family="SFProText-Bold, SF Pro Text" font-size="40" font-weight="bold" letter-spacing="0.8">
        <text id="✓" fill="#FFFFFF">
            <tspan x="6" y="41">✓</tspan>
        </text>
    </g>
</svg>